import { Composition, Folder } from "remotion";
import "./index.css";
import { EnRouteComposition } from "./compositions/EnRouteComposition";
import { PlaceComposition } from "./compositions/PlaceComposition";

export const RemotionRoot: React.FC = () => {
  return (
    <>
      <Folder name="Istanbul">
        <Composition 
          component={EnRouteComposition} 
          id="EnRoute" 
          width={720} 
          height={1080} 
          fps={30} 
          durationInFrames={5 * 30}
          defaultProps={{
            visited_countries: ["SRB", "AUT"],
            routes: [{
              id: "tauern",
              filename: "tauern.geojson",
              animated: false,
              hidden: true,
              progress: 0.01,
            }, {
              id: "optima",
              filename: "optima.geojson",
              animated: true,
              hidden: false,
              progress: 0.4,
            }],
            animatedDistance: 0.02,
          }}
        />
      </Folder>
      <Folder name="Allgemein">
        <Composition
          component={PlaceComposition}
          id="Place"
          width={1080}
          height={1920}
          fps={30}
          durationInFrames={3.5 * 30}
          defaultProps={{
            title: "döllersheim",
            marker: [15.3092, 48.6201],
            state: "Niederösterreich",
            debug: false,
          }}
        />
      </Folder>
    </>
  );
};
